"use strict";
// ref: https://github.com/GetGreenline/payment-service
Object.defineProperty(exports, "__esModule", { value: true });
exports.PaymentServiceProviderId = exports.EventRequestType = exports.RequestType = exports.EventType = exports.EventTopic = exports.Provider = exports.CountryCode = exports.SystemType = void 0;
const constants_1 = require("./constants");
var SystemType;
(function (SystemType) {
    SystemType["POS"] = "pos";
    SystemType["ECOM"] = "ecom";
})(SystemType || (exports.SystemType = SystemType = {}));
var CountryCode;
(function (CountryCode) {
    CountryCode["US"] = "us";
    CountryCode["CA"] = "ca";
})(CountryCode || (exports.CountryCode = CountryCode = {}));
var Provider;
(function (Provider) {
    Provider["ADYEN"] = "adyen";
})(Provider || (exports.Provider = Provider = {}));
var EventTopic;
(function (EventTopic) {
    EventTopic["PAYMENT"] = "payment";
    EventTopic["REFUND"] = "refund";
    EventTopic["V2_PAYMENT"] = "v2.payment";
    EventTopic["PAYMENT_FEE"] = "payment_fee";
    EventTopic["PAYMENT_TERMINAL"] = "payment_terminal";
    EventTopic["PAYMENT_CONFIG"] = "payment_configuration";
    EventTopic["PAYMENT_OPTION"] = "payment_option";
})(EventTopic || (exports.EventTopic = EventTopic = {}));
var EventType;
(function (EventType) {
    EventType["CREATED"] = "created";
    EventType["UPDATED"] = "updated";
    EventType["DELETED"] = "deleted";
})(EventType || (exports.EventType = EventType = {}));
var RequestType;
(function (RequestType) {
    RequestType["CUSTOMERS"] = "customers";
    RequestType["PAYMENTS"] = "payments";
    RequestType["REFUNDS"] = "refunds";
    RequestType["PAYMENT_FEES"] = "payment_fees";
    RequestType["PAYMENT_CONFIGS"] = "payment_configurations";
    RequestType["PAYMENT_TERMINALS"] = "payment_terminals";
    RequestType["PAYMENT_SOURCES"] = "payment_sources";
    RequestType["PAYMENT_OPTIONS"] = "payment_options";
    RequestType["PROVIDERS"] = "providers";
})(RequestType || (exports.RequestType = RequestType = {}));
var EventRequestType;
(function (EventRequestType) {
    EventRequestType["PAYMENT_EVENTS"] = "payment_events";
    EventRequestType["V2_PAYMENT_EVENTS"] = "v2.payment_events";
    EventRequestType["REFUND_EVENTS"] = "refund_events";
    EventRequestType["PAYMENT_CONFIG_EVENTS"] = "payment_configuration_events";
    EventRequestType["PAYMENT_OPTION_EVENTS"] = "payment_option_events";
    EventRequestType["PAYMENT_FEE_EVENTS"] = "payment_fee_events";
    EventRequestType["PAYMENT_TERMINAL_EVENTS"] = "payment_terminal_events";
})(EventRequestType || (exports.EventRequestType = EventRequestType = {}));
var PaymentServiceProviderId;
(function (PaymentServiceProviderId) {
    PaymentServiceProviderId["blazepay"] = "5";
    PaymentServiceProviderId["birchmount"] = "7";
})(PaymentServiceProviderId || (exports.PaymentServiceProviderId = PaymentServiceProviderId = {}));
//# sourceMappingURL=enums.js.map